// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__10qsd","footer":"Form_footer__3O41V"};